import styledComponent from 'styled-components';

const StyledImageUploadPreview = styledComponent.img`
  border-radius: 10px;
  height: auto;
  width: 100%;
`;

export default StyledImageUploadPreview;
